import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { IListResponse } from 'src/app/core';
import { IDoctor } from '../../interfaces';
import { environment as env } from 'src/environment/environment';
import { shakeParams } from '../../classes';

@Injectable({
  providedIn: 'root',
})
export class DoctorsService {
  private readonly _http: HttpClient = inject(HttpClient);

  private refetch = new Subject<void>();
  public refetch$ = this.refetch.asObservable();

  private search = new Subject<string>();
  public search$ = this.search.asObservable();

  /**
   * Retrieves a list of doctors based on the provided query parameters.
   * @param params - The query parameters to filter the list of doctors.
   * @returns An Observable emitting a list of doctors.
   */
  getAll(params: any): Observable<IListResponse<IDoctor>> {
    params = shakeParams(params);

    return this._http.get<IListResponse<IDoctor>>(`${env.apiGateway}/doctor`, {
      params,
    });
  }

  create(body: FormData): Observable<IDoctor> {
    return this._http.post<IDoctor>(`${env.apiGateway}/doctor`, body);
  }

  update(body: FormData): Observable<IDoctor> {
    return this._http.put<IDoctor>(`${env.apiGateway}/doctor`, body);
  }

  delete(id: number | string): Observable<void> {
    return this._http.delete<void>(`${env.apiGateway}/doctor/${id}`);
  }

  refetchDoctors(): void {
    this.refetch.next();
  }

  onSearch(search: string): void {
    this.search.next(search);
  }
}
